import { Box, Typography, Chip } from "@mui/material";

const KeywordListSnippet = ({ keywords = [], filterLanguage }) => {
    if (!Array.isArray(keywords) || keywords.length === 0) return null;

    const filteredKeywords = filterLanguage
        ? keywords.filter(k => k.language === filterLanguage)
        : keywords;

    if (filteredKeywords.length === 0) return null;

    return (
        <Box sx={{ mt: 2}}>
            {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                {messages.snippetKeywordsLabel}
            </Typography> */}
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1,
                }}
            >
                {filteredKeywords.map((item, index) => (
                    <Chip
                        key={index}
                        label={item.value}
                        size="small"
                        variant="outlined"
                        color="primary"
                        sx={{ fontSize: "0.85rem", fontWeight: "400" }}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default KeywordListSnippet;
